<template>
  <div id="app" :style="{ transform: 'translate(-50%, -50%) scale('+pageScale+' )'}">
    <router-link to="/start" class="homebutton">
      Zum Startbildschirm
    </router-link>
      <main>
        <router-view></router-view>
      </main>
      <footer>
          <ActionList></ActionList>
      </footer>
  </div>
</template>

<script>
import ActionList from '@/components/ActionList'
export default {
  name: 'app',
  components: {
    ActionList
  },
  data() {
    return {
      pageScale: window.innerHeight / 1200 * 1 - 0.08
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Press+Start+2P');
body,html{
  margin:0;
  padding:0;
  background: black;
  cursor: crosshair !important;
}
.font, button{
  font-family: 'Press Start 2P', Helvetica, Arial, sans-serif;
  color:white;
  //text-shadow: 2px 2px white;
}

#app{

  position: absolute;
  left: 50%;
  top: 50%;
  //transform: translate(-50%, -50%) scale(1);
  @extend .font;
  main,footer{
    width: 1280px;
    border-top: solid 5px red;
    border-left: solid 5px red;
    border-right: solid 5px red;
  }
  main{
    position: relative;
    height: 850px;
    .roomBackground{
      position: absolute;
      left:0;
      right:0;
      height: auto;
      width: 100%;
      max-height: 850px;
    }
  }
  .homebutton{
    display: block;
    width: 50%;
    position: absolute;
    top: -41px;
    right:0;
    color:white;
    text-align: right;
    text-decoration: none;
  }
}
</style>
